<template>
    <div class="content">
        <div class="left-box">
         <el-tooltip class="item" effect="dark" :content="detail.userName+'学习记录'" placement="top-start">
             <p class="title overflow">{{detail.userName}}学习记录</p>
         </el-tooltip>
            <div class="record-box" v-infinite-scroll="loadTrain">
                <no-data v-if="listData.length==0"></no-data>
                <div v-for="(item,index) in listData" class="train-item" @click="changeTrain(item)" :class="[{'line-active':studyFlag==item.studyFlag}]" :key="index">
                    <p class="software-name" :class="{'active-blue':studyFlag==item.studyFlag}">{{ item.softwareName }}</p>
                    <p class="start-time">开始时间:{{ item.startTime }}</p>
                    <div class="bottom">
                        <div>
                            <p>学习时长:</p>
                            <el-tooltip effect="dark" :content="item.onlineTime" placement="top-start">
                                 <p class="overflow" style="width: 6.5rem;">{{ item.onlineTime }}</p>
                            </el-tooltip>
                        </div>
                        <div style="margin-left: 1rem;">
                            <p>学习次数:</p>
                            <el-tooltip effect="dark" :content="item.studyCount.toString()" placement="top-start">
                             <p class="overflow" style="width: 3rem;">{{ item.studyCount }}</p>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-box">
             <div class="top-box">
                 <p class="title" style="margin-left: 2rem;">操作记录</p>
                 <div class="input-box">
                     <div @click="search">搜索</div>
                     <el-input v-model="dPages.keywords" @keydown.enter.native="search" clearable @clear="search" style="width: 20rem;" placeholder="请输入名称">
                         <template slot="prefix">
                             <div class="search-ipt-box">
                                 <img style="cursor: pointer;width: 16px;height: auto;" src="../../../assets/image/magSys/search.png" @click="search" alt="">
                             </div>
                         </template>
                     </el-input>
                 </div>
             </div>
            <div class="table-box">
                <Table
                    :totalSize="dPages.total"
                    :pagination="true"
                    :operationWidth="350"
                    :currentPage="dPages.current"
                    @changeCurrentPage="changeCurrentPage"
                    @changePageSize="changePageSize"
                    :pageSize="dPages.size"
                    navHeight=40
                    ref="table"
                    :tableData="detailList"
                    :tableKey="tableKey"
                >
                <template slot="courseCount" slot-scope="data">
                    <p style="color: #387DFF;cursor: pointer;">{{ data.data.row.courseCount }}</p>
                </template>
            </Table>
            </div>
        </div>
    </div>
 </template>
 
 <script>
 import {PageQueryCourseStudyCount,PageQueryCourseStudyDetails} from '@/api/course';
 import NoData from '@/components/common/NoData.vue';
 export default {
  components: { NoData },
         props:['detail','courseInfo','openCourseId','courseLearningSource'],
        data(){
            return {
                 dialogVisible:false,
                 studyFlag:'',
                 /**仿真软件列表 */
                 listData:[],
                 /**实训详情列表 */
                 detailList:[],
                 /**软件分页 */
                pages:{
                    current:1,
                    size:10,
                    total:0
                },
                /**详情分页 */
                dPages:{
                    current:1,
                    size:10,
                    total:0,
                    keywords:''
                },
                currentSoftware:{},
                tableKey:[
                    {name: '课程单元名称', value: 'teachingUnitName'},
                    {name: '开始时间', value: 'startTime'},
                    {name: '结束时间', value: 'endTime'},
                    {name: '完成状态', value: 'status'},
                    {name: '学习时长', value: 'studyTime'},
                ]
            }
        },
        methods:{
             search(){
                 this.dPages.current=1;
                 this.pageQueryCourseStudyDetails();
             },
              /**获取仿真软件记录 */
              pageQueryCourseStudyCount(){
                 var params={
                    "courseId": this.courseInfo.id,
                    "current": this.pages.current,
                    "openCourseId": this.openCourseId,
                    "userId":this.detail.userId,
                    "size": this.pages.size,
                    "courseLearningSource":this.courseLearningSource||'course_study'
                    }
                 if(this.userId){
                     params.userId=this.userId;
                 }
                 PageQueryCourseStudyCount(params).then(res=>{
                     if(res.code==200){
                         if(this.pages.current==1){
                             this.listData=res.data.records;
                             this.pages.total=res.data.total;
                             if(this.listData.length>0){
                                 this.studyFlag=this.listData[0].studyFlag;
                                 this.pageQueryCourseStudyDetails();
                             }else{
                                 this.studyFlag='';
                                 this.detailList=[];
                             }
                         }else{
                             this.listData=[this.listData,...res.data.records];
                             this.pages.total=res.data.total;
                         }
                     }
                 })
             },
             /**分页查询虚仿实训详情记录 */
             pageQueryCourseStudyDetails(){
                let params={
                "courseId": this.courseInfo.id,
                "current": this.dPages.current,
                "openCourseId": this.openCourseId,
                "size": this.dPages.size,
                "studyFlag": this.studyFlag,
                "name":this.dPages.keywords
                };
                 if(this.userId){
                     params.createId=this.userId;
                 }
                 PageQueryCourseStudyDetails(params).then(res=>{
                     if(res.code==200){
                         this.detailList=res.data.records;
                         this.dPages.total=res.data.total;
                     }
                 })
             },
            /**切换实训 */
            changeTrain(item){
                this.dPages.current=1;
                this.studyFlag=item.studyFlag;
                this.search();
            },
            /**下拉加载实训详情 */
            loadTrain(){
                let total=this.pages.current*this.pages.size;
                if(total>=this.pages.total)return;
                this.pages.current++;
                this.pageQueryCourseStudyCount();
                console.log('loading........')
            },
            changeCurrentPage(e){
                this.dPages.current=e;
                this.pageQueryCourseStudyDetails();
            },
            changePageSize(e){
                this.dPages.current=1;
                this.dPages.size=e;
                this.pageQueryCourseStudyDetails();
            }
        },
        mounted(){
         var html= document.getElementsByTagName('html')[0];
         window.addEventListener('resize',()=>{
             let width=html.style.fontSize;
             let arr=width.split('px');
             this.$set(this.tableKey[2],'width',(parseInt(arr[0]*15))+'px')
             this.$set(this.tableKey[3],'width',parseInt(arr[0]*15)+'px')
         })
        }
    }
 </script>
 
 <style lang="less" scoped>
 .content{
    height: 53rem;
    display: flex;
    color: #334681;
    .left-box{
        background-color: #ffffff;
        border: 1px solid #e5edf7;
         border-radius: 1.5rem;
         box-shadow: 0px 0px 1.5rem 0px rgba(231,236,239,0.10); 
         width: 25.5rem;
    }
    .right-box{
        padding: 2rem 0;
        border: 1px solid #e0e8f2;
        border-radius: 1.5rem;
        box-shadow: 0px 0px 1.5rem 0px rgba(231,236,239,0.10); 
        width: calc(100% - 27rem);
        background-color: #ffffff;
        margin-left: 1.7rem;
    }
 }
 .title{
            font-weight: 700;
            font-size: 16px;
            padding: 2rem 1.5rem;
    }
 .table-box{
    height: calc(100% - 8rem);
    width: 100%;
    margin-top: 2.5rem;
    padding: 0 2.2rem;
 }
 .record-box{
    height: calc(100% - 8rem);
    overflow:auto;
    overflow-x: hidden ;
    .train-item{
        width: 100%;
        padding: 2rem 2.1rem;
        position: relative;
        cursor: pointer;
        border-left: 3px solid transparent;
    }
 }
 .software-name{
    font-weight: 700;
 }
 .start-time{
    color: #8590B3;
    font-size: 12px;
    margin-top: 1rem;
 }
 .bottom{
    font-size: 14px;
    margin-top: 1.3rem;
    display: flex;
    justify-content: space-between;
    &> :nth-child(n){
        display: flex;
        &> :nth-child(1){
            color: #8590B3;
        }
        &> :nth-child(2){
            font-weight: 700;
        }
    }
 }
 .line-active{
     border-left: 3px solid var(--blue) !important;
     background: #f4f7fb;
 }
 /deep/.nodata-img{
    width: 12rem !important;
 }
 .input-box{
     display: flex;
     align-items: center;
     &> :nth-child(1){
     color: #8590B3;
     margin-right: 1rem;
    }
 }
 .input-box{
     margin-right: 2.2rem;
 /deep/.el-input__inner{
     height: 4rem;
     border-radius: 1rem;
     padding-left: 3.5rem;
 }
 .search-ipt-box{
     display: flex;
     align-items: center;
     width: 3.5rem;
     justify-content: center;
     height: 100%;
 }
 }
 .top-box{
     display: flex;
     align-items: center;
     justify-content: space-between;
 }
 .active-blue{
     color: var(--blue) !important;
 }
 </style>